export enum StoryDifficulty {
	Normal = 'normal',
	Hard = 'hard',
	Brutal = 'brutal',
}
